import React from "react";
import { Link } from "react-router-dom";

import { closedInterstitial, seenInterstitial } from '../../api/interstitials'

import "./Interstitials.scss";

export default function Interstitials(props) {

    let computedClassName = "main__container--interstitial"

    let bgColor = ""

    if (props.interstitialData[0]?.theme === "light") {
        computedClassName += " main__container--interstitial--light"
        bgColor = "#fff"
    }
    if (props.interstitialData[0]?.theme === "dark") {
        computedClassName += " main__container--interstitial--dark"
        bgColor = "#000"
    }
    if (props.interstitialData[0]?.picture !== null && props.interstitialData[0]?.theme === "light") {
        computedClassName += " fade__hover--light"
    }

    if (props.interstitialData[0]?.picture !== null && props.interstitialData[0]?.theme === "dark") {
        computedClassName += " fade__hover--dark"
    }

    const setExternSeenInterstitial = (id, link) => {
        seenInterstitial(id).then(() => props.handleOpeningLink(link));
    }

    // const handleRedirect = (link) => {
    //     props.handleOpeningLink(link)
    // }
    const setSeenInterstitial = (id) => {
        seenInterstitial(id)
    }

    const closeInterstitial = (id) => {
        closedInterstitial(id)
    }


    return (
        <div style={props.interstitialData[0]?.picture ? { background: `no-repeat url(${props.interstitialData[0].picture})`, backgroundSize: "cover", backgroundPosition: "center" } : { backgroundColor: `${bgColor}` }} className="container__interstitial--image">
            <div className={computedClassName}>

                <div className="container__close--button">
                    <button className="button__close--interstitial" onClick={() => {
                        closeInterstitial(props.interstitialData[0]?.id)
                        props.handleOpening()
                    }}>
                        <div className="button__close--interstitial--icon" />
                    </button>
                </div>
                <h1> {props.interstitialData[0]?.title} </h1>
                <p> {props.interstitialData[0]?.content} </p>
                {props.interstitialData[0]?.redirectionType === "internal" ?
                    <Link
                        className="button__cta--interstitial"
                        to={{
                            pathname: `${props.interstitialData[0]?.url}`,
                            state: {
                                transitionName: "fade_app",
                                entityId: props.interstitialData[0]?.entity_id
                            },
                        }}
                        onClick={() => {
                            setSeenInterstitial(props.interstitialData[0]?.id)
                            props.handleOpening()
                        }}
                    >
                        <p>{props.interstitialData[0]?.ctaContent}</p>
                    </Link>
                    :
                    <button className="button__cta--interstitial" onClick={() => {
                        setExternSeenInterstitial(props.interstitialData[0]?.id, props.interstitialData[0].url)
                        // handleRedirect()
                    }}>
                        <p>{props.interstitialData[0]?.ctaContent}</p>
                    </button>
                }
            </div>
        </div >

    );
}



